import { GET_NAC_AUTOMATION_LOGS, GET_NAC_AUTOMATION_DETAILS_BY_RITM, GET_NAC_AUTOMATION_EVENTS_BY_RITM } from "./actionTypes"

export const getNacAutomationLogsInit = (requestParams) => ({
    type: GET_NAC_AUTOMATION_LOGS.INIT,
    requestParams
})

export const getNacAutomationLogsSuccess = (logs) => ({
    type: GET_NAC_AUTOMATION_LOGS.SUCCESS,
    payload: logs
})

export const getNacAutomationLogsError = (error) => ({
    type: GET_NAC_AUTOMATION_LOGS.ERROR,
    payload: error
})

export const getNacAutomationDetailsByRitmInit = (requestId) => ({
    type: GET_NAC_AUTOMATION_DETAILS_BY_RITM.INIT,
    requestId
})

export const getNacAutomationDetailsByRitmSuccess = (details) => ({
    type: GET_NAC_AUTOMATION_DETAILS_BY_RITM.SUCCESS,
    payload: details
})

export const getNacAutomationDetailsByRitmError = (error) => ({
    type: GET_NAC_AUTOMATION_DETAILS_BY_RITM.ERROR,
    payload: error
})

export const getNacAutomatonEventsByRitmInit = (requestId, switchName, portNumber) => ({
    type: GET_NAC_AUTOMATION_EVENTS_BY_RITM.INIT,
    requestId,
    switchName,
    portNumber
})

export const getNacAutomatonEventsByRitmSuccess = (events) => ({
    type: GET_NAC_AUTOMATION_EVENTS_BY_RITM.SUCCESS,
    payload: events
})

export const getNacAutomatonEventsByRitmError = (error) => ({
    type: GET_NAC_AUTOMATION_EVENTS_BY_RITM.ERROR,
    payload: error
})